import React, { Component } from 'react';
import { changeFilter } from '../../common/services/navigation';

function MemberListOrderFilters({ search, filter }) {

	//1227
	//changeFilter(search, 'sort', 'relevance');

	// class App extends Component {
	// 	constructor(props) {
	// 		super(props)
	// 		this.state = {
	// 			selectedOption: "option1"
	// 		}
	// 	}
	// }

	const change = e => {			
		changeFilter(search, 'sort', e.target.value);
	};

	const isChecked = (key) => {
		return search.sort && search.sort === key;
	};

	return (
		<div>
			<div className="checkbox--item section--menu_item">
				<input type="checkbox" id="sortNameAsc" checked={isChecked('sortNameAsc') ? true : false} value='sortNameAsc' onChange={change} />
				<label htmlFor="sortNameAsc">Name A-Z</label>
			</div>
			<div className="checkbox--item section--menu_item">
				<input type="checkbox" id="sortNameDesc" checked={isChecked('sortNameDesc') ? true : false } value='sortNameDesc' onChange={change} />
				<label htmlFor="sortNameDesc">Name Z-A</label>
	</div>

		</div>
	);
}

export default MemberListOrderFilters;
